<template>
<ValidationObserver ref="observer">
  <form ref="add_spare_part_transfer_form" @submit.prevent="editSparePartTransfer">

    <md-card>
      <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Transfer from</label>
                  <md-select v-model="spare_part_transfer_warehouse_from_id" required>
                    <md-option v-for="option in options_warehouse_list" :key="option.value" :value="option.id">
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.spare_part_transfer_warehouse_from_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Transfer to Eshed</label>
                  <md-select v-model="spare_part_transfer_warehouse_to_id" required>
                    <md-option v-for="option in options_warehouse_list" :key="option.value" :value="option.id">
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.spare_part_transfer_warehouse_to_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100" style="margin-bottom:10px;">
              <md-field >
                <label class="label" >Remark</label>
                <md-textarea v-model="spare_part_transfer_remark" md-counter="150" maxlength="150" md-autogrow></md-textarea>
              </md-field>
            </div>
          </div>
          

          <div class="md-layout">
            <autoextra :collection="item" v-slot="{item,last,index}" >
          <div class="columns" :class="{last: last}">
              <div class="header" style="font-weight:bold; text-align:center; margin-bottom:20px; font-size:20px;">
                <label  class="label">{{last ? 'New ' : ''}}Item {{!last ? index + 1 : ''}}</label>
              </div>
              <div  class="md-layout">
                  <input v-model="item.id" type="hidden"/>
                  <input v-model="item.spare_part_transfer_item_master_id" type="hidden"/>

                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <validation-provider  v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label class="label" >Spare part Name</label>
                        <md-input  v-model="item.spare_part_name" disabled/>
                          <md-button style="background-color:green;" class="md-icon-button md-round md-info md-dense" v-on:click="modalOpenListSparePart(index)" >
                          <md-icon >search</md-icon>
                        </md-button>
                        <validation-error :errors="apiValidationErrors.spare_part_name" />
                        
                        <span class="md-error">{{ errors[0] }}</span> 
                      </md-field>
                    </validation-provider>
                  </div>
                  
                  <div class="md-layout-item md-size-20 md-small-size-50" style="margin-left:40px;">
                    <md-field >
                      <label class="label" >Stock</label>
                      <md-input  v-model="item.stock"  :readonly="true"/>
                        
                    </md-field>
                  </div>
                  
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field >
                      <label class="label" >Total Transferred</label>
                      <md-input  v-model="item.spare_part_transfer_item_qty" :disabled="item.spare_part_name==null" v-on:keypress="NumbersOnly"/>
                        
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-input  v-model="item.spare_part_transfer_item_remark" :disabled="item.spare_part_name==null"/>
                        
                    </md-field>
                  </div>
                        
                  <md-card-actions style="border:none;">
                    <md-button class="md-button-icon md-danger md-dense" @click="deleteColumn(index)">
                      delete
                    </md-button>
                  </md-card-actions>
                      
                </div> 
              </div>
            </autoextra>

          </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Submit
        </md-button>
      </md-card-actions>

      <modal ref="modalSparePart" class="coba">
            
          <template v-slot:body>
            <list-spare-part :data_id="$refs.modalSparePart.data"/>
          </template>
        </modal>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import ListSparePart from "@/pages/Dashboard/Workshop/SparePartTransfer/Modal/ListSparePart.vue";
import { required } from 'vee-validate/dist/rules';
import  Autoextra  from 'vue-autoextra';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import { Modal } from "@/components";
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);


// mengirim pesan error ketika required field tidak diisi
extend('wajib', {
  ...required,
  message: 'This field is required'
});
  
  export default {
     name: "edit-spare-part-transfer",

    props: {
      data_id:null
    },

    components: {ValidationError, Modal, ValidationObserver, "list-spare-part": ListSparePart, Autoextra },

    mixins: [formMixin],

    data: () => ({
      options_warehouse_list: null,
      spare_part_transfer_remark: null,
      spare_part_transfer_warehouse_from_id: null,
      spare_part_transfer_warehouse_to_id: null,
      item: [],
      
    }),

   async created(){
      var me = await this.$store.getters["profile/me"]
      this.division = me.role_name
      console.log(this.division);
      this.getDataSparePartTransfer();
      this.getWarehouse();
    },
   
    methods: {


      async getDataSparePartTransfer(){

        if(this.data_id.id){
          
          await this.$store.dispatch("workshop_spare_part_transfer/get", this.data_id.id)
          this.spare_part_transfer = await this.$store.getters["workshop_spare_part_transfer/spare_part_transfer"];
          
          

          this.spare_part_transfer_warehouse_from_id = this.spare_part_transfer.spare_part_transfer_warehouse_from_id
          this.spare_part_transfer_warehouse_to_id = this.spare_part_transfer.spare_part_transfer_warehouse_to_id
          this.spare_part_transfer_remark = this.spare_part_transfer.spare_part_transfer_remark
          
          

          this.spare_part_transfer.spare_part_transfer_item.forEach(async (value, index) => {

            var query = { filter: { warehouse: this.spare_part_transfer_warehouse_from_id, id: value.spare_part_transfer_item_master_id} };
              await this.$store.dispatch("workshop_spare_part_master/list", query);
            var dataStock =  await this.$store.getters["workshop_spare_part_master/list"];

            //set array berdasarkan data yang ada di item
            this.$set(this.item, index, {

                id : value.id,
                spare_part_transfer_item_master_id : value.spare_part_transfer_item_master_id,
                spare_part_name : value.spare_part.spare_part_master_name,
                stock: dataStock[0].spare_part_master_stock,
                spare_part_transfer_item_qty: value.spare_part_transfer_item_qty,
                spare_part_transfer_item_remark: value.spare_part_transfer_item_remark

                });
            });
        }
        else{
          this.$parent.$parent.modalCloseEdit();
        }
      },

      async getWarehouse(){
      await this.$store.dispatch("workshop_warehouse/list")
      this.options_warehouse_list = await this.$store.getters["workshop_warehouse/list"]
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

     // validasi menggunakan sweetalert  sebelum menambah data
    async editConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.editSparePartTransfer()
          }
        });
    },

    modalOpenListSparePart(index){
      // this.$refs.modalSparePart.openModal({dealer_id: this.procurement_order_dealer_id,index: index})
      this.$refs.modalSparePart.openModal({warehouse_id: this.spare_part_transfer_warehouse_from_id,index: index})
    },

    modalCloseListSparePart(data, index){
        // console.log(data)
        // console.log(data.spare_part_price_lower_price[0].id)
        // console.log(data.id)

        if(data.id){

          this.$set(this.item, index, {
            spare_part_transfer_item_master_id : data.id,
            spare_part_name : data.spare_part_master_name,
            stock: data.spare_part_master_stock,
            spare_part_transfer_item_qty: data.spare_part_transfer_item_qty,
            spare_part_transfer_item_remark: data.spare_part_transfer_item_remark
            
          });


            // pko_driver_kip_no_text : data.driver_no
            this.$refs.modalSparePart.closeModal()
            console.log(this.item)
        }
        

      },

    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        console.log(array.some(object => value.includes(object[key])));
        return array.some(object => value.includes(object[key]));
        },

    // fungsi add data
      async editSparePartTransfer() {
       

        const data = {
          type: "workshop_spare_part_transfers",
          // client_no: this.client_no,
          id: this.spare_part_transfer.id,
          spare_part_transfer_warehouse_from_id: this.spare_part_transfer_warehouse_from_id,
          spare_part_transfer_warehouse_to_id: this.spare_part_transfer_warehouse_to_id,
          spare_part_item: this.item,
          spare_part_transfer_remark: this.spare_part_transfer_remark
        }


        try {
        await this.$store.dispatch("workshop_spare_part_transfer/update", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        this.$parent.$parent.modalCloseEdit();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
<style lang="scss" scoped>

.divider {
  width:100px;
  border-color: black !important;
}
</style>
